import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { negativeStockSaga, setNegativeStockSaga } from './negativeStocksSaga';

export function* negativeSaga() {
  yield takeLatest(sagaActions.GET_NEGATIVE_STOCK, negativeStockSaga);
  yield takeLatest(sagaActions.EDIT_NEGATIVE_STOCK, setNegativeStockSaga);
}
